const isProduction = process.env.NODE_ENV === 'production';

export const cosSectionCode: { [key: string]: string } = {
  MAIN_AD_POPUP: isProduction ? 'P_NHQH' : 'P_NMKW',
  MAIN_NOTICE_POPUP: isProduction ? 'P_HJSC' : 'P_ODME',
} as const;
